import axios from "axios";
import WMSCapabilities from "ol/format/WMSCapabilities";
import LayerGroup from "ol/layer/Group";
import ImageLayer from "ol/layer/Image";
import ImageWMS from "ol/source/ImageWMS";
import { _serverUrl2 } from "../../../config";
import { MyMap } from "../View/MyMap";

export const addMainLayersToMap = async (_Map, Rol, isTest) => {
  await axios
    .get(_serverUrl2 + "/main/layers/web")
    .then(async (res) => {
      let filteredLayers = res.data.rows;
      if (!Rol.includes("7")) {
        filteredLayers = filteredLayers.filter((d) => d.rol != 7);
      }
      if (!Rol.includes("8")) {
        filteredLayers = filteredLayers.filter((d) => d.rol != 8);
      }
      if (!Rol.includes("4")) {
        filteredLayers = filteredLayers.filter((d) => d.rol != 4);
      }

      if (isTest) {
        filteredLayers = filteredLayers.filter((d) => d.id == 11 || d.id == 13 || d.id == 12 || d.id == 11);
      }
      if (res.data.status) {
        let length = filteredLayers.length;
        const _constant = 100;
        for (let i = 0; i < length; i++) {
          await addLayerFromPostgres(filteredLayers[i], res.data.token, (length + 2) * (_constant - i * 10));
          //await addLayerFromPostgres(filteredLayers[i],res.data.token)
        }
        MyMap.getLayers()
          .getArray()
          .sort((a, b) => {
            return b.getZIndex() - a.getZIndex();
          });
      } else {
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
const getCapabiliesByName = (name) => {
  return new Promise((resolve, reject) => {
    try {
      const parserWMS = new WMSCapabilities();
      axios
        .get(_serverUrl2 + "/main/get/capabilities")
        .then((res) => {
          return res.data;
        })
        .then((text) => {
          let result = parserWMS.read(text);
          let layer = result?.Capability?.Layer?.Layer?.find((l) => l.Name == name);
          resolve(layer);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    } catch (error) {
      console.log(error);
      reject(error);
    }
  });
};
const addLayerFromPostgres = async (l, token, zIndex) => {
  if (l.is_group) {
    let groupInfo = await getCapabiliesByName(l.params_layer.split(":")[1]);
    if (groupInfo) {
      let layerGroup = new LayerGroup({
        name: l.layer_name,
        desc: "katman",
        opacity: 1,
        svg: l.lejant,
        isSvg: l.lejant ? true : false,
        isSvgOpen: false,
        zIndex: zIndex,
        layers: groupInfo.Layer.map((layer, ind) => {
          return new ImageLayer({
            name: layer.Title,
            desc: "katman",
            opacity: 1,
            svg: l.lejant,
            isSvg: l.lejant ? true : false,
            isSvgOpen: false,
            source: new ImageWMS({
              url: l.layer_url,
              params: {
                LAYERS: layer.Name,
                t: token || undefined,
              },
              serverType: l.params_servertype,
              projection: l.params_projection,
            }),
            visible: true,
            zIndex: zIndex - ind,
          });
        }),
      });
      MyMap.addLayer(layerGroup);
    }
  } else if (l.params_token == "true" || l.params_token == true) {
    // console.log("iffff")
    let newLayer = new ImageLayer({
      name: l.layer_name,
      desc: "katman",
      opacity: 1,
      svg: l.lejant,
      isSvg: l.lejant ? true : false,
      isSvgOpen: false,
      source: new ImageWMS({
        url: l.layer_url,
        // params: { 'LAYERS': l.params_layer},
        params: { LAYERS: l.params_layer, VERSION: l.params_version, t: token },
        serverType: l.params_servertype,
        projection: l.params_projection,
      }),
      visible: l.layer_visible,
      zIndex: zIndex,
    });

    MyMap.addLayer(newLayer);
  } else {
    //console.log("elsee")
    let newLayer = new ImageLayer({
      name: l.layer_name,
      desc: "katman",
      opacity: 1,
      svg: l.lejant,
      isSvg: l.lejant ? true : false,
      isSvgOpen: false,
      source: new ImageWMS({
        url: l.layer_url,
        params: { LAYERS: l.params_layer },

        serverType: l.params_servertype,
        projection: l.params_projection,
      }),
      visible: l.layer_visible,
      zIndex: zIndex,
    });

    MyMap.addLayer(newLayer);
  }
};
